module.exports = __webpack_public_path__ + "img/member-import.3334a458.png";